import { MutableRefObject } from "react"
import { ReactFlowInstance } from "reactflow"
import { CanvasNodes, SetNodesState, UISheetType } from "../types/UITypes"
import { uuidv7 } from "uuidv7"
import { DBEntityType } from "../types/SupabaseTypesHelper"
import { SupabaseConnector } from "../database/SupabaseConnector"

export async function addConditionBlock(
  nodes: CanvasNodes,
  setNodes: SetNodesState,
  reactFlowRef: MutableRefObject<ReactFlowInstance | null>,
  supabaseConnector: SupabaseConnector
) {
  const flowChartChoiceWidth = 250
  const flowChartChoiceHeight = 115
  const centerCoords = reactFlowRef.current?.project({
    x: (window.innerWidth - flowChartChoiceWidth) / 2,
    y: (window.innerHeight - flowChartChoiceHeight) / 2,
  })

  const flowchartChoiceId = uuidv7()
  const cells = [
    {
      id: uuidv7(),
      rowIndex: 1, // used as Choice entry point and condition text
      columnIndex: 1,
      sheetId: flowchartChoiceId,
    },
    {
      id: uuidv7(),
      rowIndex: 2, // used as Choice "Yes" option
      columnIndex: 1,
      sheetId: flowchartChoiceId,
    },
    {
      id: uuidv7(),
      rowIndex: 3, // used as Choice "No" option
      columnIndex: 1,
      sheetId: flowchartChoiceId,
    },
  ]

  const updatedNodes = [
    ...nodes,
    {
      id: `sheet-${flowchartChoiceId}`,
      position: {
        x: centerCoords?.x || 0,
        y: centerCoords?.y || 0,
      },
      data: {
        id: flowchartChoiceId,
        x: centerCoords?.x || 0,
        y: centerCoords?.y || 0,
        cells,
        columns: [],
        edgeHandles: [],
        width: flowChartChoiceWidth,
        height: flowChartChoiceHeight,
      },
      width: flowChartChoiceWidth,
      height: flowChartChoiceHeight,
      type: UISheetType.CONDITION,
    },
  ]

  setNodes(updatedNodes)

  await supabaseConnector.addSheet(
    centerCoords!,
    flowchartChoiceId,
    cells,
    [],
    DBEntityType[UISheetType.CONDITION]
  )
}
